'use client';

import { ReviewDetailSessionPortal } from '@/app/donation/_components/ReviewDetailSessionPortal';
import { DONATION_ROUTES } from '@/constants';
import { useCustomRouter } from '@/hooks/useCustomRouter';

interface ReviewDetailControllerProps {
  reviewId?: number;
  productNumber: string;
}

export const ReviewDetailController = ({
  reviewId,
  productNumber,
}: ReviewDetailControllerProps) => {
  const router = useCustomRouter();

  const isOpen = Boolean(reviewId);

  const handleClose = () => {
    const currentSearchParams = new URLSearchParams(location.search);
    currentSearchParams.delete('detailReviewId');

    router.replace(
      DONATION_ROUTES.GIFTS_DETAIL.withSearchParams({
        dynamicPath: { productNumber },
        searchParams: Object.fromEntries(currentSearchParams),
      }),
      { scroll: false },
    );
  };

  return (
    <ReviewDetailSessionPortal
      open={isOpen}
      onClose={handleClose}
      reviewId={reviewId}
    />
  );
};
